
<div id="eng_dynamicHeight" appSpin [spinnerConfig]='spinnerConfig()' class="position-relative" [ngClass]="{'workbook-preview h-100': placeOfPreview === 'Workbook', 'eng-preview page A4' : placeOfPreview !== 'Workbook' }">

</div>

